import Link from "next/link";
import { useRouter } from "next/router";

import HeaderSearchBar from "./headerSearchBar";

import GreenLogo from "../../public/img/green-logo-2.png";

import Image from "next/image";

type BlogHeaderProps = {};

export default function BlogHeader({}: BlogHeaderProps) {
  const { isPreview } = useRouter();

  return (
    <header className="bg-bi-green-deep-teal-950 pl-2 pr-1 sm:pl-4 md:pr-4 lg:px-8 w-full fixed z-50">
      <nav className="h-16">
        {!isPreview && (
          <>
            <div className="absolute h-full flex flex-col justify-center ml-1 md:ml-0">
              <Link href="/blog" className="h-min">
                <Image src={GreenLogo} alt="" className="h-8 w-auto" />
                {/* <img
                  className="h-8 w-auto"
                  src="/img/biclick-onb.svg"
                  alt="BI Click"
                /> */}
              </Link>
            </div>

            <div className="h-full flex flex-row justify-center items-center">
              <HeaderSearchBar />
            </div>
          </>
        )}
      </nav>
    </header>
  );
}
